import { climateApi, walterBIApi } from '../clients/AxiosClients'

export const getDashboardData = () => {
	return walterBIApi.get('v1/DashboardAnalitycs/GetDashboardData')
}

export const getClimateData = ({ farmId, startTimestamp, endTimestamp }) => {
	const params = new URLSearchParams()
	params.append('FarmId', farmId)
	params.append('StartTimestamp', startTimestamp / 1000)
	params.append('EndTimestamp', endTimestamp / 1000)
	return climateApi.get('/Climate', { params: params })
}

export const getBalancoHidricoSerieMensal = (farmId) => {
	return climateApi.get('/BalancoHidrico/serie-mensal', { params: { farmId } })
}

export const getDashboardConfiguration = () => {
	return walterBIApi.get('v1/DashboardAnalitycs/GetDashboardConfiguration')
}

export const saveDashboardConfiguration = (configuration) => {
	return walterBIApi.post('v1/DashboardAnalitycs/SaveDashboardConfiguration', configuration)
}

export const getDashboardPicked = (configuration) => {
	return walterBIApi.post(`v1/DashboardAnalitycs/DatePicked?date=${configuration}`)
}
